import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { Country } from '../model/country.model';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface CountryState<T extends Country> extends EntityState<T> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'country', idKey: 'shtCountryID' })
export class CountryStore<T extends Country> extends EntityStore<CountryState<T>> {
  constructor() {
    super();
  }
}
